import { io } from 'socket.io-client';
import { auth } from './firebase';

let socket = null;

export const connectSocket = async () => {
  const user = auth.currentUser;
  if (!user) return null;

  const token = await user.getIdToken();

  socket = io(process.env.REACT_APP_SOCKET_URL || window.location.origin, {
    auth: { token },
    autoConnect: true,
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 10,
  });

  socket.io.on('reconnect_attempt', async () => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      const freshToken = await currentUser.getIdToken(true);
      socket.auth = { token: freshToken };
    }
  });

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
